export default __webpack_public_path__ + "static/media/ask_ai_anything.574ad3d9.svg";